import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SlideImage from '../Components/SlideImage';

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <SlideImage />

      <div className="bg-neutral-100 py-10 px-6 md:px-20 md:mx-32 my-8 space-y-20">

        <div className="flex flex-col lg:flex-row items-center gap-10">
          <img
            src="assets/dog16.jpg"
            alt="Volunteer Help"
            className="rounded-md w-full h-64 object-cover lg:w-1/2"
          />
          <div className="lg:w-1/2">
            <h2 className="text-xl md:text-2xl font-semibold">Help when it's needed</h2>
            <p className="text-gray-600 mt-3">
              We need volunteers to help find our rescue animals loving homes. We would absolutely love it if you could join our foster program.
            </p>
            <button
              className="mt-6 bg-green-600 text-white px-6 py-2 rounded-md hover:scale-105 transition-transform"
              onClick={() => navigate('/')}
            >
              Read more about what we do
            </button>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row-reverse items-center gap-10">
          <img
            src="assets/dog11.jpg"
            alt="Feeding Program"
            className="rounded-md w-full h-64 object-cover lg:w-1/2"
          />
          <div className="lg:w-1/2">
            <h2 className="text-xl md:text-2xl font-semibold">
              Do you want to be part of the Street Dog Feeding Program?
            </h2>
            <p className="text-gray-600 mt-3">
              Join us in feeding street animals! We can provide and transport the food to you, but we need your help in catching and safely trapping street dogs and cats for spaying and neutering.
            </p>
            {/* <button
              className="mt-6 bg-green-600 text-white px-6 py-2 rounded-md hover:scale-105 transition-transform"
              onClick={() => navigate('/join-feeding')}
            >
              Join Now
            </button> */}
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-10">
          <img
            src="assets/dog17.jpg"
            alt="Guardian Program"
            className="rounded-md w-full h-64 object-cover lg:w-1/2"
          />
          <div className="lg:w-1/2">
            <h2 className="text-xl md:text-2xl font-semibold">The Guardian Program</h2>
            <p className="text-gray-600 mt-3">
              In this program we encourage you to take a dog out for a day outing such as a drive or walk or take them home for a few days. This will help the dogs with socialization and prepare them for future adoption.
            </p>
            <button
              className="mt-6 bg-green-600 text-white px-6 py-2 rounded-md hover:scale-105 transition-transform"
              onClick={() => navigate('/guardian/guardian-form')}
            >
              Guardian form ↓
            </button>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row-reverse items-center gap-10">
          <img
            src="assets/dog6.jpg"
            alt="Puppy Training School"
            className="rounded-md w-full h-64 object-cover lg:w-1/2"
          />
          <div className="lg:w-1/2">
            <h2 className="text-xl md:text-2xl font-semibold">Puppy Training School</h2>
            <p className="text-gray-600 mt-3">
              A well trained and socialised dog leads to a happy and healthy relationship between humans and dogs. <br /> <strong>Disclaimer:</strong> All payments made to our puppy training school will go towards financing our shelter.
            </p>
            <button
              className="mt-6 bg-green-600 text-white px-6 py-2 rounded-md hover:scale-105 transition-transform"
              onClick={() => navigate('/Training_school')}
            >
              Explore Training School
            </button>
          </div>
        </div>

        <div className="flex justify-center mt-10">
          <Link to="/page-donate">
            <button className="bg-orange-600 text-white px-10 py-3 text-lg rounded-md hover:scale-105 transition-transform">
              Make a Donation
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Home;
